export enum SearchPopupPhase {
  Closed = 'closed',
  Open = 'open',
  Closing = 'closing'
}
